
import React, { useState } from 'react';
import ApiKeyInput from '@/components/api-docs/ApiKeyInput';
import SwaggerUIContainer from '@/components/api-docs/SwaggerUIContainer';
import { ScrollArea } from '@/components/ui/scroll-area';

function ApiDocs() {
  const [apiKey, setApiKey] = useState('');
  const [expandedView, setExpandedView] = useState(true);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-6 px-4">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">API Documentation</h1>
          <div className="flex items-center space-x-2">
            <label htmlFor="expanded-view" className="text-sm font-medium">
              {expandedView ? 'Collapse All' : 'Expand All'}
            </label>
            <input
              id="expanded-view"
              type="checkbox"
              checked={expandedView}
              onChange={() => setExpandedView(!expandedView)}
              className="rounded border-gray-300"
            />
          </div>
        </div>
        
        <ApiKeyInput apiKey={apiKey} setApiKey={setApiKey} />
        
        <div className="mt-6 bg-white border rounded-lg shadow">
          <ScrollArea className="h-[75vh]">
            <SwaggerUIContainer apiKey={apiKey} docExpanded={expandedView} />
          </ScrollArea>
        </div>
      </div>
    </div>
  );
}

export default ApiDocs;
